import michaelScholz from "@/assets/michael-scholz-new.jpg";
export const StorySection = () => {
  return <section id="about" className="story-section py-16 sm:py-32 bg-gradient-story relative">
      <div className="container mx-auto px-4 sm:px-8">
        {/* Enhanced Asymmetric Story Layout - Mobile Optimized */}
        <div className="grid lg:grid-cols-5 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Portrait with Enhanced Depth */}
          <div className="lg:col-span-2 animate-scale-in order-2 lg:order-1">
            <div className="relative max-w-sm mx-auto lg:max-w-none">
              {/* Background accent elements - adjusted for mobile */}
              <div className="absolute -top-4 -left-4 sm:-top-8 sm:-left-8 w-16 h-16 sm:w-24 sm:h-24 rounded-full opacity-15 sm:opacity-20 floating-element" style={{
              background: 'hsl(210 65% 32% / 0.15)'
            }}></div>
              <div className="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-20 h-20 sm:w-32 sm:h-32 rounded-full opacity-8 sm:opacity-10 floating-element" style={{
              background: 'radial-gradient(circle, hsl(210 65% 32% / 0.2) 0%, transparent 70%)',
              animationDelay: '1s'
            }}></div>
              
              <img src={michaelScholz} alt="Michael Scholz - Gründer Scholz Interim" className="w-full rounded-2xl sm:rounded-3xl shadow-story relative z-10" />
              
              {/* Accent border highlight */}
              <div className="absolute inset-0 rounded-2xl sm:rounded-3xl opacity-15 sm:opacity-20 pointer-events-none border" style={{
              borderColor: 'hsl(210 65% 32%)'
            }}></div>
            </div>
          </div>
          
          {/* Story Content with Enhanced Typography - Mobile Optimized */}
          <div className="lg:col-span-3 animate-fade-in order-1 lg:order-2">
            <div className="mb-6 sm:mb-8 relative">
              
              
              {/* Integrated Slogan - Mobile Responsive */}
              <div className="mb-6 sm:mb-8">
                <div className="flex flex-wrap items-center gap-1.5 sm:gap-4 mb-4 sm:mb-6">
                  <span className="text-xl sm:text-2xl font-display font-light text-primary">
                    Potenziale.
                  </span>
                  <span className="text-xl sm:text-2xl font-display font-light text-primary">
                    Finden.
                  </span>
                  <span className="text-xl sm:text-2xl font-display font-light text-primary">
                    Zusammen.
                  </span>
                </div>
                <div className="w-full h-px bg-gradient-to-r from-primary via-primary/60 to-transparent"></div>
              </div>
            </div>

            <h2 className="text-4xl sm:text-5xl font-display font-extralight bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent mb-6 sm:mb-8 leading-[0.9] relative">
              »Es geht um Menschen,
              <span className="block font-story italic text-xl sm:text-3xl mt-2" style={{
              color: 'hsl(210 65% 32%)'
            }}>
                nicht um Profile.«
              </span>
              {/* Decorative accent - hidden on mobile */}
              <div className="hidden sm:block absolute -left-6 top-0 w-1 h-12 sm:h-16 bg-gradient-to-b from-primary to-transparent opacity-30 rounded-full"></div>
            </h2>
            
            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-muted-foreground leading-relaxed font-light relative">
              {/* Subtle background accent - hidden on mobile */}
              <div className="hidden lg:block absolute -right-8 top-8 w-64 h-64 rounded-full opacity-[0.03] pointer-events-none" style={{
              background: 'radial-gradient(circle, hsl(210 65% 32%) 0%, transparent 70%)'
            }}></div>
              
              <p className="relative z-10">Als ich vor 25 Jahren Scholz Interim gründete, blickte ich bereits auf eine erfolgreiche Laufbahn als Führungskraft in der Hotellerie zurück und lernte, dass die besten Kandidaten nicht immer im Lebenslauf stehen, sondern sich häufig zwischen den Zeilen verstecken.</p>
              
              <p className="relative z-10">
                Heute, nach über 900 erfolgreichen Vermittlungen in der Personalvermittlung und im Executive Search, weiß ich: Hospitality ist Herzensangelegenheit. 
                Jede Position, die wir besetzen, verändert nicht nur ein Unternehmen – sie prägt Gästeerlebnisse, 
                formt Unternehmenskulturen und schreibt Erfolgsgeschichten.
              </p>
              
              <p className="font-medium text-foreground relative z-10 pl-3 sm:pl-4 border-l-2 border-primary/20">Deshalb arbeiten wir nicht nur mit Algorithmen, sondern mit Instinkt und Erfahrung. Nicht ausschließlich mit Datenbanken, sondern mit jahrzehntelangen Beziehungen.</p>
            </div>

            <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-6">
              <div className="text-left sm:text-right">
                <div className="font-display font-medium text-foreground text-lg sm:text-base">Michael Scholz</div>
                <div className="text-sm text-muted-foreground">Gründer & Geschäftsführer</div>
              </div>
              <div className="hidden sm:block w-12 sm:w-16 h-px bg-gradient-to-r from-primary to-transparent"></div>
              <div className="hidden sm:block w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
              backgroundColor: 'hsl(210 65% 32% / 0.6)'
            }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};